import React from 'react'
import IconTooltipButton from '../button/IconTooltipButton'
import { useSnackbar } from 'notistack'
import { Typography } from '@mui/material'

const TextCopyClipboard = ({ text }) => {
  const { enqueueSnackbar } = useSnackbar()
  
  return (
    <div className='flex gap-2 items-center justify-between border-b'>
      <Typography className='overflow-hidden'>{text}</Typography>
      <IconTooltipButton 
        title='Copy to clipboard' 
        onClick={() => {
          navigator.clipboard.writeText(text)
          enqueueSnackbar('Copied to clipboard', { variant: 'success' })
        }}
        color='primary'
        icon={['fas', 'copy']} 
      />
    </div>
  )
}

export default TextCopyClipboard